import React from 'react';
import GamesGrid from '../Components/GameGrid';
import styled from 'styled-components';
import NavBar from '../Components/Header';

const DragonForged = styled.h2`
  margin-bottom: 10px;
  margin-left: 10px;
  font-family: 'Dragonforged', sans-serif;
  background: linear-gradient(180deg, orange, yellow);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
`;

const Games = styled.h2`
  margin-bottom: 10px;
  margin-left: 5px;
  font-family: 'Dragonforged', sans-serif;
`;

const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background-color: #213; // Change the color as needed
  color: white;
`;

const Logo = styled.img`
  height: 50px; // Adjust as needed
  margin-right: 10px;
`;

const RightLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const ArcadeText = styled.span`
  font-family: 'Arcade Alternate', sans-serif;
  font-size: 18px;
  color: white;
  margin-right: 5px;
`;

const DragonForgedLink = styled.span`
  font-family: 'Arcade Alternate', sans-serif;
  background: linear-gradient(180deg, orange, yellow);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  font-size: 25px;
`;

const Menu = () => {
  return (
    <div>
      <TopBar>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Logo src={"/Logo.png"} alt="Logo" />
          <DragonForged>Dragonforged</DragonForged>
          <Games>Arcade</Games>
        </div>
        <RightLink href="https://x.com/intent/follow?screen_name=dragonmastereth" target="_blank" rel="noopener noreferrer">
          <ArcadeText>Games by</ArcadeText>
          <DragonForgedLink>DragonmasterDX.eth</DragonForgedLink> 
        </RightLink>
      </TopBar>
      <GamesGrid />
    </div>
  );
};

export default Menu;
